<template>
    <div class="list">
        <el-form :model="dioForm" label-width="150px" label-position="right" label-suffix="：">
            <el-row>
                <el-col :span="12" v-for="item in baseMsgArray" :key="item.key">
                    <el-form-item :label="$t(item.text)">

                        <template v-if="item.key === 'isHeart'">

                            <span v-if="!isEdit">
                                {{ heartFn(item.key) }}
                            </span>
                            <el-checkbox v-else v-model="dioForm['isHeart']" :true-label="1" :false-label="0">
                            </el-checkbox>
                        </template>

                        <template v-else-if="item.key === 'description'">

                            <span v-if="!isEdit">
                                {{ dioForm.description }}
                            </span>

                            <el-input v-else type="textarea" v-model="areaValue" maxlength="250"
                                :autosize="{ minRows: 3, maxRows: 4 }" style="width:200px" show-word-limit></el-input>

                        </template>

                        <template v-else-if="item.key === 'nickname'">

                            <span v-if="!isEdit">
                                {{ dioForm.nickname }}
                            </span>

                            <el-input v-else type="text" v-model="nickname" style="width:200px" maxlength="30">
                            </el-input>

                        </template>

                        <template v-else>

                            <span>{{ textChangeFn(item.key) }}</span>
                        </template>

                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item v-if="isEdit">
                <el-button type="primary" @click="saveDecFn">
                    <i class="el-icon-folder-checked button-icon "></i>
                    {{ $t("public.save") }}
                </el-button>
                <el-button type="primary" @click="goBack"><i class="el-icon-refresh-left button-icon"></i>{{ $t("返回") }}
                </el-button>
            </el-form-item>
            <el-form-item v-if="!isEdit">
                <el-button type="primary" @click="goBack"><i class="el-icon-edit button-icon"></i>{{ $t('public.edit')
                }}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    props: ['baseMsgArray', 'detailObj', 'isMode'],
    watch: {
        detailObj(newVal) {
            this.dioForm = { ...newVal }
        },
        isMode(newVal) {
            this.isEdit = newVal;
            // this.areaValue = this.detailObj['description']
            // this.nickname = this.detailObj['nickname']
            this.dioForm.isHeart = this.detailObj.isHeart
        }
    },
    data() {
        return {
            dioForm: {},
            nickname: '',
            areaValue: '',
            isEdit: false,
            /** 配置状态 */
            configIconArray: [
                {
                    value: 0,
                    icon: 'el-icon-set-up',
                    label: this.$t('device.wait_config')
                },
                {
                    value: 1,
                    icon: 'el-icon-connection',
                    label: this.$t('device.configuring')
                },
                {
                    value: 2,
                    icon: 'el-icon-odometer',
                    label: this.$t('device.configured')
                }
            ],
        }
    },
    methods: {
        heartFn(key) {
            return this.dioForm[key] === 1 ? this.$t('public.btn_yes') : this.$t('public.btn_no')
        },
        TOODChange(value, array) {
            var param = ''
            for (let item of array) {
                if (item.value === value) {
                    param = item['label']
                    break
                }
            }
            return param
        },
        textChangeFn(key) {
            let detailObj = this.dioForm;
            switch (key) {
                case 'status':
                    {
                        return detailObj[key] === 1 ? this.$t('public.online') : this.$t('public.stop')
                    }
                case 'configStatus':
                    {
                        return this.TOODChange(detailObj[key], this.configIconArray)
                    }
                case 'code':
                    {
                        return detailObj[key] === 'gt_2' ? $t('deviceType.gt_2') : $t('deviceType.gt_1')
                    }
                case 'edited':
                    {
                        return detailObj[key] === 1 ? this.$t('public.btn_yes') : this.$t('public.btn_no')
                    }
                case 'parameterStatus':
                    {
                        return detailObj[key] === 0 ? $t('integration.normal_reporting_data') : $t('integration.no_gateway_zigbee_parameter')
                    }
                case 'createTime':
                    {
                        return this.$timetransition(detailObj[key])
                    }
                case 'powerStatus':
                    {
                        return detailObj[key] === 0 ? this.$t('device.normal_power_supply') : this.$t('device.no_power_supply')
                    }
                // case 'tcpStatus':
                //     {
                //         return detailObj[key] === 0 ? $t('integration.tcp_connection_service_exception') : $t('integration.tcp_connection_service_is_normal')
                //     }
                // case 'lteStatus':
                //     {
                //         return detailObj[key] === 0 ? $t('integration.lte_connection_server_exception') : $t('integration.lte_connection_server_is_normal')
                //     }
                // case 'flightMode':
                //     {
                //         return detailObj[key] === 0 ? $t('integration.not_in_flight_mode') : $t('integration.flight_mode')
                //     }

                default:
                    break;
            }
            return detailObj[key]
        },
        goBack() {
            this.areaValue = this.detailObj['description']
            this.nickname = this.detailObj['nickname']
            this.dioForm.isHeart = this.detailObj.isHeart
            this.isEdit = !this.isEdit;
        },
        saveDecFn() {
            const { id, isHeart } = this.dioForm
            this.$emit('saveDecFn', { id, isHeart, nickname: this.nickname, areaValue: this.areaValue })
        }
    }
}
</script>

<style lang="scss" scoped>
.list {
    flex: 1;
}

::v-deep .button-icon {
    margin: 0;
    color: white;
    font-size: 14px;
    font-weight: 100;
    margin-right: 5px;
}
</style>